import { useRouter } from 'next/router';

interface FromContext {
  from: string | null;
  sessionId: string | null;
  /** The route prefix the user came from, so back-navigation can land on the
   *  exact route (`/scribe/session` vs. `/scribe/sessions`) instead of the
   *  always-singular default. */
  fromPath: string | null;
}

const resolveFromContext = (pathname: string, sessionId: string | null): FromContext => {
  if (pathname === '/patients') {
    return { from: 'patients', sessionId: null, fromPath: null };
  }
  if (pathname.startsWith('/scribe/sessions')) {
    return { from: 'session', sessionId, fromPath: '/scribe/sessions' };
  }
  if (pathname.startsWith('/scribe/session')) {
    return { from: 'session', sessionId, fromPath: '/scribe/session' };
  }
  return { from: null, sessionId: null, fromPath: null };
};

/** Navigate to `/patients/[id]` with `from` / `fromPath` query params so the
 *  breadcrumb on the full-page view can route the user back to the exact
 *  origin route (patients list, `/scribe/session`, or `/scribe/sessions`). */
export const useOpenPatientFullPage = () => {
  const router = useRouter();

  return (patientId: string | null | undefined): boolean => {
    if (!patientId) return false;
    const currentSessionId = Array.isArray(router.query.id)
      ? router.query.id[0]
      : router.query.id;
    const { from, sessionId, fromPath } = resolveFromContext(
      router.pathname,
      typeof currentSessionId === 'string' ? currentSessionId : null
    );
    const query: Record<string, string> = {};
    if (from) query.from = from;
    if (sessionId) query.sessionId = sessionId;
    if (fromPath) query.fromPath = fromPath;
    void router.push({ pathname: `/patients/${patientId}`, query });
    return true;
  };
};
